import { omit } from "lodash";
import toPairs from 'lodash.topairs';
import { SET_ALL_DATA, SET_ITEM, DELETE_ITEM } from "../actions";

export const clients = (state = {}, action) => {
    switch(action.type) {
        case SET_ALL_DATA: {
            return { ...state, data: action.payload  }
        }
        case SET_ITEM: {
            const { id, data } = action.payload;
            return {...state, data: {...state.data, [id]: data} };
        }
        case DELETE_ITEM: {
            const { id } = action.payload
            return { ...state, data: omit(state.data, [id]) }
        }
        default:
            return state
    }
}

export const getClientsData = clients => fromObjToArray(clients)

const fromObjToArray = tasks => (
    toPairs(tasks).map(([key, value]) => ({ ...value, id: key }))
);